<template>
    <div v-if="discussZone.list.length > 0" class="discussZone pb-show-display" :data-pblog="pblogData">
        <div class="title">{{ discussZone.moduleName }}</div>
        <div class="content">
            <div ref="copys" class="name">
                <img :src="discussZone.list[0].publisher_header" class="headimg">
                <div class="discussTitle">{{ discussZone.list[0].publisher }}</div>
            </div>
            <!-- eslint-disable -->
            <div
                ref="zoneCon"
                class="con clamp-content"
                :class="clampContent ? 'clamp-content-3' : ''"
            >
                <span
                    v-for="(item, index) in infoList"
                    :class="item.type === 2 ? 'link' : item.type === 3 ? 'copy' : 'noraml'"
                    @click.stop="clickProcess(item)"
                >
                    <span v-if="item.type === 3" class="psd">
                        <!-- {{item.content}} -->
                        <b
                            v-clipboard:copy="item.content"
                            v-clipboard:success="copy"
                            v-clipboard:error="copyError" 
                        >
                            {{item.label}}
                        </b>
                    </span>
                    <br v-else-if="item.type === 4" />
                    <span v-else>
                        {{item.label}}
                    </span>
                </span>
            </div>
            <div
                v-if="showOpen"
                class="open"
                @click.stop="openCon">
                <span>{{ isOpen }}</span>
                <img :src="icDown" class="ic_down">
            </div>
        </div>
        <!-- 复制成功Toast -->
        <div v-if="openToast" class="copy-success">
            已复制到剪贴板
        </div>
    </div>
</template>

<script>
    import icDown from 'public/assets/imgs/ic_down_grey.png';
    import icUp from 'public/assets/imgs/ic_up_grey.png';
    export default {
        props: {
            discussZone: {
                type: Object,
                default: () => ({})
            }
        },
        data() {
            return {
                icDown: icDown,
                clampContent: true,
                isOpen: '展开',
                openToast: false,
                infoList: [],
                showOpen: false,
                pblogData:{}
            }
        },
        created() {
            this.initInfo();
        },
        mounted() {
            
            let height = this.$refs.zoneCon.offsetHeight;
            if (height > 46) {
                this.showOpen = true;
            }

            this.pblogData = JSON.stringify({
                value: 'module',
                ext: {
                    item: [
                        {
                            id: '',
                            ext:{
                                ...this.$root.extData,
                                moduleName:'爆料专区'
                            },
                            pos: ''
                        }
                    ]
                }
            })
            
            
        },
        methods: {
            openCon() {
                this.clampContent = !this.clampContent;
                if (this.clampContent) {
                    this.isOpen = '展开';
                    this.icDown = icDown;
                } else {
                    this.isOpen = '收起';
                    this.icDown = icUp;
                }
            },
            copy() {
                this.openToast = true;
                setTimeout(()=> {
                    this.openToast = false;
                }, 3000)
            },
            copyError() {
                console.log('复制失败');
            },
            initInfo() {
                if (!this.discussZone.list) {
                    return;
                }
                const text = this.discussZone.list[0].show_text;
                // console.log(text);
                // const text = '哈哈哈哈<br>哈哈哈哈&&$$c复制号码$$c##c17811486690##c&&&&$$a百度一下$$a##ahttp://baidu.com##a&&hhhhhhh&&$$a百度二下$$a##ahttp://baidu.com##a&&yyyyy&&$$a百度三下$$a##ahttp://baidu.com##a&&兔兔兔兔兔兔图&&$$c复制号码$$c##c17811486690##c&&';
                this.textList = this.convertText(text) || [];
            },
            convertText(text) {
                let infoList = [];
                const firstList = text.split('&&');
                firstList.forEach((item) => {
                    const info = this.convertDyn(item);
                    if (Array.isArray(info)) {
                        infoList = infoList.concat(info);
                    } else {
                        infoList.push(info);
                    }
                });
                this.infoList = infoList;
            },
            convertDyn(text) {
                if (text.includes('$$a')) {
                    const label = text.split('$$a')[1];
                    const content = text.split('##a')[1];
                    return {
                        label,
                        content,
                        type: 2
                    }
                } else if (text.includes('$$c')) {
                    const label = text.split('$$c')[1];
                    const content = text.split('##c')[1];
                    return {
                        label,
                        content,
                        type: 3
                    }
                } else if (text.includes('<br>')) {
                    const textList = text.split('<br>');
                    const list = [];
                    textList.forEach((item, index) => {
                        if (index + 1 !== textList.length) {
                            list.push({
                                label: textList[index],
                                type: 1
                            });
                            list.push({
                                label: '',
                                type: 4
                            });
                        } else {
                            list.push({
                                label: textList[index],
                                type: 1
                            });
                        }
                    });
                    // console.log(list);
                    return list;
                } else {
                    return {
                        label: text,
                        type: 1
                    }
                }
            },
            clickProcess(item) {
                if (item.type === 2) {
                    window.location.href = item.content
                }
            }
        }
    }
</script>

<style lang="scss">
    @import "~@/common/style/mixin/utils";
    $design-width: 1242;
    .discussZone {
        color: #1F1F1F;
        font-weight: 400;
        .title {
            font-size: px2rem(57);
            letter-spacing: 0;
            line-height: px2rem(57);
            font-weight: 500;
            padding: px2rem(75) 0 px2rem(54);
            font-weight: bold;
        }
        .content {
            width: px2rem(1110);
            background: #F8F8F8;
            border-radius: px2rem(36);
            padding: 0 px2rem(36) px2rem(65);
            margin-left: px2rem(-20);
            .name {
                display: flex;
                justify-content: flex-start;
                padding: px2rem(45) 0 px2rem(31.5);
                .headimg {
                    width: px2rem(84);
                    height: px2rem(84);
                    border-radius: 50%;
                    border: px2rem(1) solid rgba(0,0,0,0.10);
                }
                .discussTitle {
                    font-size: px2rem(48);
                    font-weight: 500;
                    line-height: px2rem(84);
                    margin-left: px2rem(18);
                }
            }
            .con {
                max-width: px2rem(1110);
                font-size: px2rem(48);
                text-align: justify;
                line-height: px2rem(75);
                padding: 0;
            }
            .open {
                font-size: px2rem(48);
                color: #858585;
                text-align: justify;
                line-height: px2rem(48);
                padding-top: px2rem(55.5);
                text-align: center;
                .ic_down {
                    width: px2rem(40);
                    margin-left: px2rem(18);
                }
            }
            .psd {
                font-weight: 700;
            }
            .link {
                color: #3388FF;
                text-decoration: underline;

            }
            .copy {
                color: #3388FF;
            }
        }
        .copy-success {
            width: px2rem(442);
            background: rgba(0,0,0,0.80);
            border-radius: px2rem(24);
            padding: px2rem(42) 0;
            font-size: px2rem(48);
            color: #FFFFFF;
            letter-spacing: 0;
            text-align: center;
            line-height: px2rem(48);
            font-weight: 400;
            text-align: center;
            position: fixed;
            top: 50%;
            left: 50%;
            margin-left: px2rem(-221);
            margin-top: px2rem(-66);
        }
    }
</style>